import React, { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentSettings: FC<{ fillColor?: string } & SvgProps> = ({
  fillColor = '#212121',
  ...props
}) => (
  <Svg
    width={24}
    height={24}
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <Path
      d='M12.012 2.25c.734.008 1.465.093 2.182.253a.75.75 0 01.582.649l.17 1.527a1.384 1.384 0 001.927 1.116l1.401-.615a.75.75 0 01.85.174 9.792 9.792 0 012.204 3.792.75.75 0 01-.271.825l-1.242.916a1.381 1.381 0 000 2.226l1.243.915a.75.75 0 01.272.826 9.797 9.797 0 01-2.204 3.792.75.75 0 01-.848.175l-1.407-.617a1.38 1.38 0 00-1.926 1.114l-.169 1.526a.75.75 0 01-.572.647 9.518 9.518 0 01-4.406 0 .75.75 0 01-.572-.647l-.168-1.524a1.382 1.382 0 00-1.926-1.11l-1.406.616a.75.75 0 01-.849-.175 9.798 9.798 0 01-2.204-3.796.75.75 0 01.272-.826l1.243-.916a1.38 1.38 0 000-2.226l-1.243-.914a.75.75 0 01-.271-.826 9.793 9.793 0 012.204-3.792.75.75 0 01.85-.174l1.4.615a1.387 1.387 0 001.93-1.118l.17-1.526a.75.75 0 01.583-.65c.717-.159 1.45-.243 2.201-.252zm0 1.5a9.135 9.135 0 00-1.354.117l-.109.977A2.886 2.886 0 016.525 7.17l-.898-.394a8.293 8.293 0 00-1.348 2.317l.798.587a2.881 2.881 0 010 4.643l-.799.588c.32.842.776 1.626 1.348 2.322l.905-.397a2.882 2.882 0 014.017 2.318l.11.984c.889.15 1.798.15 2.687 0l.11-.984a2.881 2.881 0 014.018-2.322l.905.396a8.296 8.296 0 001.347-2.318l-.798-.588a2.881 2.881 0 010-4.643l.796-.587a8.293 8.293 0 00-1.348-2.317l-.896.393a2.884 2.884 0 01-4.023-2.324l-.11-.976a8.988 8.988 0 00-1.333-.117zM12 8.25a3.75 3.75 0 110 7.5 3.75 3.75 0 010-7.5zm0 1.5a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z'
      fill={fillColor}
    />
  </Svg>
)
export default FluentSettings
